// extracted by mini-css-extract-plugin
module.exports = {"resetPasswordLayout":"layout_resetPasswordLayout__teJ0P"};